import { useEffect, useRef, useState, useCallback } from "react";
import { Rothko } from "web/script/modules/rothko";

/**
 * Provides a ref with a rothko instance for manual data fetching
 */
export function useRothkoFetcher<T>(path: string, cache = true): [Rothko<T>["fetch"], boolean] {
    const rothko = useRef<Rothko<T>>();
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        rothko.current = new Rothko(path, { cache });
    }, [path, cache]);

    const fetch = useCallback(async function fetch(
        ...args: Parameters<Rothko<T>["fetch"]>
    ): Promise<T> {
        setLoading(true);
        if (!rothko.current) {
            throw new Error("Rothko is missing!");
        }
        try {
            return await rothko.current.fetch(...args);
        } finally {
            setLoading(false);
        }
    },
    []);

    return [fetch, isLoading];
}
